export function isStaging(host: string) {
  return host.includes('zapier-staging.com');
}

// Visual Builder application depends on ZAPIER_APP_BASE_URL to get to the
// monolith locally, in staging or production. We're at Visual Builder when we
// see this environment variable.
export function isAtVB() {
  return !!process.env.ZAPIER_APP_BASE_URL;
}
